/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Per spec §8.5: ``step_index`` is 1-indexed for human display.
 */
export interface SequenceMini {
  id: string;
  name: string;
  /** @minimum 1 */
  step_index: number;
}
